"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Qiniu = exports.SHARD_THRESHOLD = void 0;
const tslib_1 = require("tslib");
const runtime_1 = require("../../runtime");
const data_iterator_1 = require("../../data-iterator");
const shard_uploader_1 = require("./shard-uploader");
exports.SHARD_THRESHOLD = 1024 * 1024 * 64;
class Qiniu {
    upload(name, data, tokens, options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const dataIterator = (0, data_iterator_1.tryToCreateDataIterator)(data, shard_uploader_1.CHUNK_SIZE, exports.SHARD_THRESHOLD);
            if (dataIterator) {
                return new shard_uploader_1.ShardUploader(tokens, dataIterator).upload(name, options);
            }
            const { status, body } = yield runtime_1.SDKRuntime.http.upload({
                method: 'POST',
                url: tokens.upload_url,
                file: { name, data, field: 'file' },
                form: { name, key: tokens.key, token: tokens.token },
                header: options === null || options === void 0 ? void 0 : options.header,
            }, options);
            if (status >= 400) {
                throw new Error(body.error);
            }
        });
    }
}
exports.Qiniu = Qiniu;
